import Shortcut from "@/components/shortcut";
import * as signals from "@/signals";
import { t } from "i18next";
import { JSX } from "react";

function ShortcutBackIcon(): JSX.Element {
	const handleClick = (): void => {
		signals.currentFolder.value = null;
	};

	return (
		<Shortcut
			dragId=""
			hasPopup={true}
			isDraggable={false}
			isInDock={false}
			item={{
				icon: "\ue7ee",
				itemType: "action",
				onClick: handleClick,
				title: t("back"),
				url: "",
			}}
		/>
	);
}

export default ShortcutBackIcon;
